import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '@/src/store/rootReducer'

export interface ITokenState {
  accessToken: string | null
}

export const initialTokenState: ITokenState = {
  accessToken: null,
}

export const tokenSlice = createSlice({
  name: 'token',
  initialState: initialTokenState,
  reducers: {
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload
    },
    clearAccessToken: (state) => {
      state.accessToken = null
    },
  },
})

export const { setAccessToken, clearAccessToken } = tokenSlice.actions

export const selectAccessToken = (state: RootState) => state.token.accessToken

